<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" lg="4" md="6" sm="8">
        <v-card class="mx-auto">
          <v-container>
            <v-card-title>
              <v-layout align-center justify-center>
                <v-img src="@/assets/securating_logo.png"
                       @click="$router.push('/login')"
                       class="tw-cursor-pointer"
                       contain
                       max-width="200"
                />
              </v-layout>
            </v-card-title>

            <v-card-title>
              {{ $t("registration.title") }}
            </v-card-title>

            <!-- Registration form -->
            <v-card-text class="tw-mt-2">
              <Form ref="verification" :callback="registrationUser">
                <FormField v-model="form.user.email"
                  i18n="registration.form.user.email"
                  input-type="email"
                  rules="required|email"
                />
                <FormField v-model="form.user.user_name"
                  i18n="registration.form.user.user_name"
                  input-type="text"
                  rules="required"
                />
                <FormField v-model="form.user.password"
                  :input-type="showPassword ? 'text' : 'password'"
                  i18n="registration.form.user.password"
                  rules="required"
                >
                  <template #append>
                    <v-icon v-if="showPassword" small @click="showPassword = false">fa-eye</v-icon>
                    <v-icon v-else small @click="showPassword = true">fa-eye-slash</v-icon>
                  </template>
                </FormField>
                <div>
                  <span>{{ $t("registration.form.legal.me.i_accept_legals") }}</span>
                  <a href="https://www.securating.com/docs/cg/cgu-securating.pdf" target="_blank">
                    {{ $t("registration.form.legal.me.link_accept_legals") }}
                  </a>
                  <span>{{ $t("registration.form.legal.me.i_accept_privacy") }}</span>
                  <a
                    href="https://www.securating.com/docs/charte/charte-du-respect-de-la-vie-privee.pdf"
                    target="_blank"
                  >
                    {{ $t("registration.form.legal.me.link_accept_privacy") }}
                  </a>
                  <span>{{ $t("registration.form.legal.me.i_accept_newsletter") }}</span>
                </div>

                <div class="mt-4 mb-2">
                  <router-link to="/login">
                    {{ $t("login.return") }}
                  </router-link>
                </div>

                <Captcha @verify="captchaResolved = true"></Captcha>

                <v-btn :disabled="!captchaResolved" class="mt-4 primary" block @click="$refs.verification.validate()">
                  {{ $t("registration.submit") }}
                </v-btn>
              </Form>
            </v-card-text>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Types as TypesSnackbar } from "@/store/modules/snackbar"
import Captcha from "@/components/common/Form/Captcha"

export default {
  name: "Registration",
  components: {
    Captcha,
  },
  data: () => ({
    step: 1,
    showPassword: false,
    captchaResolved: false,
    form: {
      user: {
        email: null,
        user_name: null,
        password: null,
        accept_legals: null,
      },
    },
  }),
  methods: {
    registrationUser() {
      return new Promise((resolve, reject) => {
        this.form.user.accept_legals = true
        this.$axios
          .post("/office/me/users", this.form.user)
          .then(() => {
            this.$store.dispatch(TypesSnackbar.actions.PUSH_MESSAGE, {
              lines: this.$t("registration.form.success"),
              config: { timeout: 1000 * 6, color: "success" },
            })

            window.setTimeout(() => {
              this.$router.push("/login")
              resolve()
            }, 6000)
          })
          .catch(errors => {
            reject(errors.response.data)
          })
      })
    },
  },
}
</script>
